import React from 'react'
import styles from './style/benefits_section_style.module.scss'
import Typography from '../../design-system/foundations/typography/Typography'
import Grid from '../../design-system/foundations/grid/Grid'
import Cell from '../../design-system/foundations/grid/Cell'
import Benefit from '../../design-system/moleculars/benefit/Benefit'
import Translation from '../../global/Translation'

const Benefits = () => {

    return (
        <div className={styles['benefits']}>
            <Typography className={styles['benefits-title']} typeface="title-xl-light">
                <Translation id="natural_stone_benefits" defaultMessage="NATURAL STONE BENEFITS"/>
            </Typography>

            <Grid wide className={styles['benefits-grid']}>
                <Cell col-4 wide className={styles['benefits-column']}>
                    <Benefit icon="type_quality" >
                        <Translation id="top_quality" defaultMessage="Top quality" />
                        <Translation id="top_quality_benefit_desc" defaultMessage="Cosentino ensures the highest quality standards throughout the extraction and processing of natural stone."/>
                    </Benefit>
                </Cell>
                <Cell col-4 className={styles['benefits-column']}>
                    <Benefit icon="type_stain" >
                        <Translation id="stain_resistant_protection" defaultMessage="Stain-resistant protection" />
                        <Translation id="stain_resistant_benefit_desc" defaultMessage="Breakthrough treatment integrated into the molecular structure of the stone."/>
                    </Benefit>
                </Cell>
                <Cell col-4 className={styles['benefits-column']}>
                    <Benefit icon="type_low" >
                        <Translation id="low_maintenance" defaultMessage="Low maintenance" />
                        <Translation id="low_maintenance_benefit_desc" defaultMessage="Its treatment extends the life cycle of your worktop. No sealing is required and it is easy to clean."/>
                    </Benefit>
                </Cell>
                <Cell col-4 className={styles['benefits-column']}>
                    <Benefit icon="type_unique" >
                        <Translation id="unique_look" defaultMessage="Unique look" />
                        <Translation id="unique_look_benefit_desc" defaultMessage="Exclusive selection of natural stones with unique designs to create outstanding spaces."/>
                    </Benefit>
                </Cell>
                <Cell col-4 className={styles['benefits-column']}>
                    <Benefit icon="type_in_out" >
                        <Translation id="for_indoor_outdoor_use" defaultMessage="For indoor and outdoor use" />
                        <Translation id="indoor_outdoor_use_benefit_desc" defaultMessage="Unique and combined pieces for indoor and outdoor use."/>
                    </Benefit>
                </Cell>
                <Cell col-4 className={styles['benefits-column']}>
                    <Benefit icon="type_time" >
                        <Translation id="unchanged_over_time" defaultMessage="Unchanged over time" />
                        <Translation id="unchanged_over_time_benefit_desc" defaultMessage="Cosentino Natural Stone is effectively maintained over time."/>
                    </Benefit>
                </Cell>
            </Grid>
        </div>
    )
};

export default Benefits;